<template>
	<v-container fluid class="ma-0 pa-0">
		<v-col class="ma-0 pa-0" cols="12" id="head_title">
			<v-col class="ma-0 pa-0" cols="12" id="head_body">
				<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
					<v-row class="ma-0 pa-0" align="center" justify="start" id="header_height">
						<v-col class="ma-0 pa-0" cols="auto">{{tsc('storeSearch')}}</v-col>
					</v-row>
				</v-col>
			</v-col>
			<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
				<v-row class="ma-0 pa-2 pt-4 pl-5 pr-0 pb-2" align="center">
					<v-col class="ma-0 pa-0" cols="10">
						<v-row class="ma-0 pa-0" align="center" justify="start">
							<v-col class="ma-0 pa-0" cols="auto" style="font-size:0.9rem">
								{{ tsc('brandSelect') + ' : '}}
							</v-col>
							<v-col class="ma-0 pa-0" id="brand_box">
								<template v-if="brandLoading == false">
									<template v-if="brandList.length > 0">
										<v-item-group class="ma-0 pa-0" dense v-model="selectedBrands" dark
											hide-details :column="false" multiple>
											<v-row class="ma-0 pa-0" align="center">
												<v-col class="ma-0 pa-0 ml-2 mb-2" cols="auto" 
													v-for="(item, index) in brandList" :key="index">
													<v-item :value="item" v-slot="{ active, toggle }">
														<v-col class="ma-0 pa-2 grey_item" cols="auto" @click="toggle"
															:class="{'selected_item':active}">
															<v-row class="ma-0 pa-0" align="center">
																<template v-if="active">
																	<input id="check_box" type="checkbox" :checked="active" />
																</template>
																<template v-else>
																	<input id="check_box" type="checkbox" :checked="active" />
																</template>
																<v-col class="ma-0 pa-0 ml-2" cols="auto">
																	{{item.brandName + ' (' + item.count + ')'}}
																</v-col> 
															</v-row>
														</v-col>
													</v-item>  
												</v-col>
											</v-row>       
										</v-item-group>
									</template>
									<template v-else>
										<v-col class="ma-0 pa-0 pl-3" cols="3" align="left" style="font-size:0.9rem">
											{{t('noData')}}
										</v-col>
									</template>
								</template>
								<template v-else>
									<v-col class="ma-0 pa-0 pl-3" cols="auto" align="left">
										<v-progress-circular indeterminate color="white"
											:width="4" :size="30"></v-progress-circular>
									</v-col>
								</template>
							</v-col>
						</v-row>
					</v-col>
					<v-col class="ma-0 pa-0" cols="2">
						<v-btn v-if="searchEnable == false"
							width="95%" height="auto" class="ma-0 pa-2" 
							id="grey_btn" elevation="0" style="border:none;">
							{{tsc('listing')}}
						</v-btn>
						<v-btn v-else
							width="95%" height="auto" class="ma-0 pa-2" 
							@click="goStoreDetail" :loading="searchLoading"
							id="blue_btn" elevation="0">
							{{tsc('listing')}}
						</v-btn>
					</v-col>
				</v-row>
				<template v-if="areaLoading == false">
					<v-col class="ma-0 pa-2 pl-5 pr-5 pb-2" cols="12"
						v-if="selectedBrands.length != 0">
						<v-row class="ma-0 pa-0" align="center">
							{{ tsc('theConditions') + ' : '}}
							<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-3" 
								v-if="uacSupport"
								id="back_clean_btn" elevation="0" @click="filterDialogVisible = true">
								<v-row class="ma-0 pa-0" align="center" style="color:white;">
									<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
										src="@/assets/images/plus_round.png"></v-img>
									{{tsc('filtering')}}	
								</v-row>
							</v-btn>
							<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-3" 
								id="back_clean_btn" elevation="0" @click="tagDialogVisible = true">
								<v-row class="ma-0 pa-0" align="center" style="color:white;">
									<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
										src="@/assets/images/plus_round.png"></v-img>
									{{tsc('tag')}}	
								</v-row>
							</v-btn>
						</v-row>
					</v-col>
					<template v-if="originStoreList.length != 0">
						<v-col class="ma-0" cols="auto"
							style="border-bottom: 1px solid #4A4A4A; padding-left:2.7rem;"
							v-if="selectedBrands.length != 0">
							<v-row class="ma-0 pa-0" align="center">
								<input id="check_box" type="checkbox" 
									v-model="selectedBrand.allSelect" v-on:change="selecteBrandChange"/>
								<v-col class="ma-0 pa-0 ml-3" cols="auto">{{'すべての店舗' + ' (' + storeTotal + ')'}}</v-col>
							</v-row>
						</v-col>
					</template>
				</template>
			</v-col>
		</v-col>
		<v-col id="main_content" class="ma-0 pa-0" cols="12">
    	<v-col class="pa-0" id="main_content_maxwidthset" cols="12">
				<template v-if="areaLoading == false">
					<v-col class="ma-0 pa-0" cols="12" id="store_list">
						<template v-if="originStoreList.length != 0">
              <v-col class="ma-0 pa-0">
                <v-treeview class="ma-0 pa-0" selected-color="blue"
							  	selectable dark dense v-model="selectedRegions"
							  	:items="selectedBrand.regions" item-key="id">
							  	<template v-slot:label="{item, leaf}">
                    <v-col class="ma-0 pa-2" cols="auto"
											v-if="!leaf">
							  			{{item.id + ' (' + item.value.length + ')'}}
							  		</v-col>
										<v-col class="ma-0 pa-2" cols="auto"
											v-else>
							  			{{item.id}}
							  		</v-col>
							  	</template>
							  </v-treeview>
              </v-col>
						</template>
						<template v-else-if="originStoreList.length == 0 && selectedBrands.length != 0">
							<v-col class="ma-0 pa-10">
								{{t('noData')}}
							</v-col>
						</template>
					</v-col>
				</template>
				<template v-else>
					<v-col class="ma-0 pa-2" cols="12" align="left">
						<v-skeleton-loader
							:boilerplate="false" elevation="0" dark 
							type="list-item-three-line, list-item-two-line, list-item-three-line"
						></v-skeleton-loader>
					</v-col>
				</template>

				<FilterDialog :dialogVisible="filterDialogVisible" :brandBoxVisible="false"
					@visible="filterDialogVisibleFunc" @filterParams="filterParamsFunc" />
				<TagDialog :dialogVisible="tagDialogVisible"
					@tagVisible="tagDialogVisibleFunc" @tagNames="tagNamesFunc" />
			</v-col>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import SearchIcon from '../../assets/SearchIcon.vue'
import FilterDialog from '@/components/dialogs/FilteringDialog.vue';
import TagDialog from '@/components/dialogs/TagDialog.vue';
import { BrandListTest } from '../whitetest/sampleData';
export default {
	components: {
		FilterDialog, TagDialog, SearchIcon
	},
	mixins: [mixin.common],
	data: () => ({
		userConfig: {},
		selectedBrand: { brandCd: '' },
		selectedBrands: [],
		filterDialogVisible: false,
		tagDialogVisible: false,
		selectedRegions: [],
    brandList: [],
		brandLoading: false,
    areaList: [],
		areaLoading: false,
		brandListTest: BrandListTest,
		// brandTotal: 0,
		searchLoading: false,
    storeTotal: 0,
		originStoreList: [],
		filterConditions: {
			motionBeginDate: '',
			motionEndingDate: '',
			soundBeginDate: '',
			soundEndingDate: '',
		},
		tagNames: '',
		searchEnable: false,
		uacSupport: true,
	}),
	watch: {
		selectedBrands: function(item) {
			this.selectedBrand.allSelect = false;
      this.selectedRegions = [];
			console.log('%cselectedBrands\n', "color:#008DD0;", item);
			if(item.length > 0) {
        this.getAreaData();
      } else {
				this.storeTotal = 0;
				this.areaList = [];
				this.selectedBrand.regions = [];
			}
		},
		selectedRegions: function(item) {
			console.log('%cselectedRegions\n', "color:#008DD0;", item);
			if(item.length == 0) this.searchEnable = false;
			else this.searchEnable = true;
		},
	},
	computed: {
		totalCameraCount() {
      return this.$store.getters.getTotalCameraCount;
    },
	},
  ready: function() {
    this.selecteBrandChange();
  },
	created() {
		this.userConfig = this.$store.getters.getUserConfig;
		this.uacSupport = this.$store.getters.getUacSupport;
	},
	mounted() {
		this.getBrandData();
		this.$store.commit('setSearchCondition', {
			selectedBrands: this.selectedBrands,
			selectedAreas: this.makeAreaList(),
			setFilterConditions: this.filterConditions,
			tagNames: this.tagNames
		});
	},
	methods: {
		tsc(t) {
			return this.$t("lang.storeSearch." + t);
    },
		selecteBrandChange() {
			if(this.selectedBrand.allSelect) {
				this.selectedBrand.regions.forEach((region) => {
					region.children.forEach((item) => {
						this.selectedRegions.push(item.id);
					});
				});
			} else {
				this.selectedRegions = [];
			}
		},
		selectBrand(brand) {
			this.selectedBrand = brand;
			this.selectedBrand.allSelect = false;
      this.getAreaData(); //area list 가 따로 오기 때문에 다시 받아줘야 함
		},
		filterDialogVisibleFunc(visible) {
			this.filterDialogVisible = visible;
		},
		tagDialogVisibleFunc(visible) {
			this.tagDialogVisible = visible;
		},
		async goStoreDetail() {
			if(this.selectedBrands.length == 0) return;
			await this.requestSearch();
		},
		async getBrandData() {
			this.brandLoading = true;
			let params = {};
			await this.networkController.getBrandList(params).then(async (res) => {
				console.log('%cBrand Data\n', "color:#008DD0;", res.data);
				this.brandLoading = false;
        this.brandList = res.data;
			}).catch(error => {
				this.brandLoading = false;
			});
		},
		makeBrandCd() {
			if(this.selectedBrands.length == 0) return '';
			return new Promise((resolve, reject) => {
				let brandCd = '';
				this.selectedBrands.forEach((item, index) => {
					if(index == 0) brandCd = item.brandCd;
					else brandCd = brandCd + ',' + item.brandCd;
				});
				// brandCd = this.selectedBrands.brandCd;
				resolve(brandCd);
			});
		},
    async getAreaData() {
			this.areaLoading = true;
			let brandCd = await this.makeBrandCd();
			let params = {};
      this.storeTotal = 0;

			await this.networkController.getStoresSearch(params, '', brandCd, 
				this.filterConditions.motionBeginDate, this.filterConditions.motionEndingDate,
				this.filterConditions.soundBeginDate, this.filterConditions.soundEndingDate,
				this.tagNames, '')
			.then(async (res) => {
				console.log('%cArea Search Result\n', "color:#008DD0;", res.data);
				this.storeTotal = res.data.length;
				this.originStoreList = res.data;
				if(this.userConfig.printCityName) {
					let group1 = this.groupBy(res.data, data => data.unisCustomerPref)
					group1.forEach((item, index) => {
						let group2 = this.groupBy(item.value, data => data.areaName)
						group1[index].children = group2;
						group2.forEach((item, index2) => {
							let group3 = this.groupBy(item.value, data => data.unisCustomerName)
							group2[index2].children = group3;
						})
					})
					this.areaList = group1;
					this.selectedBrand.regions = group1;
				} else {
					let group1 = this.groupBy(res.data, data => data.unisCustomerPref)
					group1.forEach((item, index) => {
						let group2 = this.groupBy(item.value, data => data.unisCustomerName)
						group1[index].children = group2;
					})
					this.areaList = group1;
					this.selectedBrand.regions = group1;
				}
				this.selectedBrand.brandCd = brandCd;
				this.areaLoading = false;
			}).catch(error => {
				this.areaLoading = false;
			});
    },
		async requestSearch() {
			this.searchLoading = true;
			const searchData = await this.makeSearchData();
			console.log('%cSearch Result Data\n', "color:#008DD0;", searchData);
			if(searchData.length == 0) {
				this.searchLoading = false;
				this.showToastMessage(this.tmb('noStoresFound'));
				return;
			}
			let makeSearchResult = [];
			searchData.forEach((item) => {
				item.checked = false;
				makeSearchResult.push(item);
			});
			this.$store.commit('setStoreSearchResult', makeSearchResult);
			this.$store.commit('setSearchCondition', {
				selectedBrands: this.selectedBrands,
				selectedAreas: this.makeAreaList(),
				setFilterConditions: this.filterConditions,
				tagNames: this.tagNames
			});
			this.searchLoading = false;
			this.pushRoute('/store-search/detail', {});
		},
		makeAreaStr() {
			return new Promise((resolve, reject) => {
				let areaStr = '';
				this.selectedRegions.forEach((item, index) => {
					let store = this.originStoreList.find((el, index, arr) => el.unisCustomerName === item);
					if(index == 0) {
						areaStr = areaStr + store.areaCd;
					} else {
						areaStr = areaStr + ',' + store.areaCd;
					}
				});
				resolve(areaStr);
			});
		},
		makeAreaList() {
			let result = [];
			this.selectedRegions.forEach((item, index) => {
				let store = this.originStoreList.find((el, index, arr) => el.unisCustomerName === item);
				if(store != undefined) result.push(store.areaName);
			});
			return result;
		},
		makeSearchData() {
			return new Promise((resolve, reject) => {
				let result = [];
				this.selectedRegions.forEach((item, index) => {
					let store = this.originStoreList.find((el, index, arr) => el.unisCustomerName === item);
					if(store != undefined) result.push(store);
				});
				resolve(result);
			});
		},
		filterParamsFunc(params) {
			this.filterConditions = params;
			setTimeout(() => {
				this.getAreaData();
			}, 100);
		},
		tagNamesFunc(tagNames) {
			this.tagNames = tagNames;
			setTimeout(() => {
				this.getAreaData();
			}, 100);
		},
	}
}
</script>

<style lang="scss" scoped>
#head_title {
	position: sticky;
	top: 0;
	z-index: 10;
	background-color: #222222;
}
#head_body {
	background-color: #272A33;
}
#header_height {
	height: 50px;
}
#main_content {
	position: relative;
	min-height: 1350px;
	height: calc(1350px - 330px);
}

.v-input {
	font-size: 0.8rem !important;
}
.v-label {
	font-size: 0.8rem !important;
}
::v-deep {
	.v-text-field--rounded > .v-input__control > .v-input__slot {
		padding: 0 8px;
		min-height: 30px !important;
	}
	.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
		min-height: 30px;
	}

	// 트리뷰 체크박스 CSS
	.v-treeview-node__checkbox { 
		background-color: white;
		border-radius: 5px;
		width: 18px;
		height: 18px;
		margin-left: 8px;
		margin-right: 5px;
	}
	.v-treeview--dense .v-treeview-node__root {
		border-bottom: 1px solid #4A4A4A;
	}
	.v-treeview-node__children {
		display: flex;
		flex-wrap: wrap;
		.v-treeview-node__root {
			border-bottom: none;
		}
	}
	
	// v-skeleton-loader css 설정
	.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-three-line {
		background: #222222 !important;
	}
	.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-two-line {
		background: #222222 !important;
	}
}
.grey_item {
	cursor: pointer;
	border: 1px solid #6A6A6A;
	background-color: #4E4E4E;
	border-radius: 4px;
	color: white;
	min-width: 1rem;
}
.selected_item {
	cursor: pointer;
	background-color: #4E4E4E;
	border-radius: 4px;
	color: white;
	min-width: 1rem;
	border: 1px solid #6A6A6A;
}
#store_list {
  text-align: left;
  // height: 29rem;
  // overflow-y: auto;
	// &::-webkit-scrollbar {
	// 	width: 3px;
	// }
	// &::-webkit-scrollbar-thumb {
	// 	background-color: white;
	// }
	// &::-webkit-scrollbar-track {
	// 	background-color: #4A4A4A;
	// }
}
#brand_box {
	max-height: 9rem;
  overflow-y: auto;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
</style>